/* Change animation playback speed without moving its current position. */
(() => {
  if (customElements.get('sam-logo-marquee')) return;

  class SamLogoMarquee extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      const section = this.closest('.sam-expert-logos');
      if (!section) return;
      section.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') {
          this.setSpeed(Number(this.dataset.hoverSpeed) || 0.25);
        }
      }, { signal });
      section.addEventListener('pointerleave', () => this.setSpeed(1), { signal });
    }

    setSpeed(speed) {
      this.getAnimations().forEach((animation) => animation.updatePlaybackRate(speed));
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  }

  customElements.define('sam-logo-marquee', SamLogoMarquee);
})();
